import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { StatesSelectComponent } from './states/states-select.component';

@NgModule({
    declarations: [
        StatesSelectComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        StatesSelectComponent
    ],
    providers: []
})
export class SelectsModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/selects/selects.module.ts